package api

@Suppress("ClassName")
sealed class HardwareCapability(val mask: Int, val label: String) {
    data object UNDEFINED : HardwareCapability(0, "NONE")
    data object VIDEO_FHD : HardwareCapability(2, "FHD")
    data object VIDEO_UHD : HardwareCapability(4, "UHD")
    data object APPS : HardwareCapability(8, "APPS")

    infix fun match(mask: Int): Boolean = this.mask and mask > 0

    companion object {
        val all by lazy {
            listOf(UNDEFINED, VIDEO_FHD, VIDEO_UHD, APPS)
        }

        operator fun get(mask: Int): HardwareCapability {
            return all.firstOrNull {
                it.mask == mask
            } ?: UNDEFINED
        }
    }
}
